module.exports = __webpack_public_path__ + "static/media/19ESCAP2.7a2254fd.jpg";